<template>
  <main>
    <div v-if="!displaying" class="card mt-4 text-center d-block pt-4 pb-4">
      <div class="spinner-border text-info" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div v-if="displaying">
      <div class="row">
        <div class="col-md-12">
          <TopTemplate>
            <template #right-element> </template>
            <template #left-element>
              <h3>{{ $t("title.parametrageServices") }}</h3>
            </template>
          </TopTemplate>
        </div>
      </div>
      <div class="ajout-container row bloc container-select container-filter">
        <div class="col-sm-8 container-select container-filter top-filter">
          <div class="info-filter">
            <p>{{ $t("common.c_recherche") }}</p>
          </div>
        </div>
        <div v-if="isSelected" class="col-sm-4 container-select container-filter top-filter">
          <div class="reset_student reset_note" @click="resetFilter()">
            <i class="icon-reset" />
            {{ $t("notes.reset") }}
          </div>
        </div>
        <div class="supparation"></div>

        <div class="row container-select container-filter top-register">
          <div class="col-md-5 col-12 select-wrapper bloc-title">
            <div>
              <v-select
                v-model="selectedLevel"
                :searchable="true"
                :options="levels2"
                label="name"
                class="form-control"
                :reduce="(option) => option"
                @update:modelValue="ChangeLevel($event)"
                placeholder="Niveau"
              >
                <template #no-options="{search, searching, loading}">
                  <div v-if="!loading" class="card mt-2 text-center d-block pt-2 pb-2">
                    {{ $t("common.emptysearshType") }}
                  </div>
                  <div v-else class="card mt-2 text-center d-block pt-2 pb-24">
                    <div class="spinner-border text-info" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </div>
                </template>
              </v-select>
            </div>
          </div>
          <div class="col-md-5 col-12 select-wrapper">
            <div>
              <v-select
                v-model="selectedClass"
                :options="classes"
                label="name"
                placeholder="Classe"
                :searchable="true"
                :disabled="!selectedLevel || selectedLevel.length === 0"
                :reduce="(option) => option"
                class="form-control"
                @update:modelValue="ChangeClass($event)"
              >
                <template #no-options="{search, searching, loading}">
                  <div v-if="!loading" class="card mt-2 text-center d-block pt-2 pb-2">
                    {{ $t("common.emptysearchClasse") }}
                  </div>
                  <div v-else class="card mt-2 text-center d-block pt-2 pb-24">
                    <div class="spinner-border text-info" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </div>
                </template>
              </v-select>
            </div>
          </div>
        </div>
      </div>
      <div v-if="loading" class="card mt-4 text-center d-block pt-4 pb-4">
        <div class="spinner-border text-info" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <div v-else>
        <div v-if="noLevels" class="container-fluid empty-message card mt-4">
          <div class="col-12 empty-result text-center pt-3">
            <p>{{ $t("common.emptysearchClasse") }}</p>
          </div>
        </div>

        <div v-else class="table classe">
          <div class>
            <div class="row">
              <div class="classes-liste spec-classe">
                <div class="table">
                  <div class>
                    <div class="table__wrapper">
                      <table class="table__classes">
                        <thead>
                          <tr class="item_class">
                            <th></th>

                            <th v-for="(service, index) in services" :key="index">
                              {{ service.name }}
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr v-for="(level, index) in levels" :key="index">
                            <td :class="'level-' + level.id" colspan="6" class="td_content_all">
                              <table class="item_table_classes" width="100%">
                                <thead>
                                  <tr class="item_level item_class">
                                    <td class="level-name" style="cursor: pointer; z-index: 9" @click="level.Active = !level.Active">
                                      <i v-if="level.name" class="arrow down arrow-collapse" :class="[level.name ? (level.Active ? 'toRotate' : '') : 'space-right']" />
                                      {{ level.name }}
                                    </td>
                                    <td v-for="(service2, index) in services" :key="index" class=""></td>
                                  </tr>
                                </thead>
                                <tbody v-if="level.Active">
                                  <tr v-if="level.students.length > 0" class="tout-selectionne">
                                    <td>{{ $t("common.toutSelectionner") }}</td>
                                    <td v-for="(service2, index) in services" :key="index" class="">
                                      <label class="container-checkbox">
                                        <input
                                          type="checkbox"
                                          :checked="testAllStudentsWithServiceInLevel(level, service2.id)"
                                          @change="selectAllStudents(service2, level, $event)"
                                        />
                                        <span class="checkmark" />
                                      </label>
                                    </td>
                                  </tr>
                                  <tr v-for="student in level.students" :key="student.id" class="item_class">
                                    <td class="name-eleve">{{ student.first_name }} {{ student.last_name }}</td>
                                    <td v-for="(service2, index) in services" :key="index" class="">
                                      <label class="container-checkbox">
                                        <input
                                          type="checkbox"
                                          :id="'service_' + service2.id + '_student_' + student.student_id"
                                          :value="service2.id"
                                          :disabled="isLoading"
                                          :checked="hasService(student, service2.id)"
                                          @change="updateServiceStatus(level, student, service2.id, service2.price.price, $event, service2)"
                                        />
                                        <span class="checkmark" />
                                      </label>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <div v-if="last_page > 1" class="col-md-12">
                        <div class="table__wrapper__pagination-wrapper">
                          <div class="pagination">
                            <pagination v-if="last_page > 1" :data-set="pagination" @goToPage="getResults" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
    
<script>
import vSelect from "vue-select";

import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
//import buttonElement from "../../components/buttons/Button.vue";
//import TableClasses from "../../components/tables/TableClasses.vue";
import ClasseService from "../../services/classe.service";
import PaymentService from "../../services/payment.service";
import ServicesService from "../../services/services.service";
import pagination from "../../components/navigation/Pagination";

//import VueMask from 'v-mask';
export default {
  name: "ParamService",

  components: {
    TopTemplate,
    "v-select": vSelect,
    pagination,
  },

  data() {
    return {
      displaying: false,
      allServicesSelected: true,
      loading: false,
      classes: [],
      levels2: [],
      noLevels: false,
      pagination: {},
      last_page: null,
      total: 0,
      groupByType: [],
      services: [],
      selectedLevel: null,
      selectedClass: null,
      selectedCourse: null,
      courses: [],
      levels: [],
      isLoading: false,
      params: {
        q: "",
        order: true,
        limit: 10,
        page: 1,
        sort: "name",
        class: null,
        type: null,
      },
      selectedServices: {},
    };
  },
  mounted() {
    this.loading = true;
    this.LevelsList();
    this.ListServices();
    this.FilterRegister();
  },
  methods: {
    sortItemsLevel(levelsList) {
      return [...levelsList].sort((a, b) => a.name.localeCompare(b.name));
    },
    resetFilter() {
      (this.isSelected = false), (this.selectedLevel = null), (this.selectedClass = null), (this.params.class = null), (this.params.level = null);
      this.getResults();
    },
    // testAllStudentsWithServiceInLevel(level, serviceId) {
    //   for (const student of level.students) {
    //     if (!this.hasService(student, serviceId)) {
    //       return false; // Dès qu'un élève n'a pas ce service, retournez false
    //     }
    //   }
    //   return true; // Si tous les élèves ont le service, retournez true
    // },
    hasService(student, serviceId) {
      const service = student.services.find((s) => s.service_id === serviceId);
      return service ? service.service_is_active === 1 : false;
    },

    testAllStudentsWithServiceInLevel(level, serviceId) {
      return level.students.every((student) => this.hasService(student, serviceId));
    },
    selectAllStudents(service2, level, event) {
      const isChecked = event.target.checked;

      level.selectAll = isChecked;

      level.students.forEach((student) => {
        const existingService = student.services.find((service) => service.service_id === service2.id);

        if (!existingService) {
          student.services.push({
            service_id: service2.id,
            service_is_active: isChecked ? 1 : 0,
            price_service: service2.price.price,
          });
        } else {
          existingService.service_is_active = isChecked ? 1 : 0;
        }
      });

      const formattedData = level.students.map((student) => ({
        student_id: student.student_id,
        services: student.services.map((service) => ({
          ...service, // Spread the existing service properties
        })),
      }));

      const requestData = {
        students: formattedData,
      };

      PaymentService.updateStatus(requestData);
    },

    // hasService(student, serviceId) {
    //   const service = student.services.find((s) => s.service_id === serviceId);
    //   return service ? service.service_is_active === 1 : false;
    //   // return !!student.services.find((s) => s.service_id === serviceId)?.service_is_active === 1;
    // },

    updateServiceStatus(level, student, serviceId, priceService, event, service2) {
      const allSelected = level.students.every((s) => this.hasService(s, serviceId));
      // Mettre à jour l'état de la case "Tout sélectionner" pour ce service
      if (allSelected) {
        service2.selectAll = !allSelected;
      }
      this.isLoading = true; // Indique que le chargement est en cours
      const isChecked = event.target.checked;
      const updatedServices = [...student.services];
      const existingServiceIndex = updatedServices.findIndex((service) => service.service_id === serviceId);

      if (existingServiceIndex === -1) {
        updatedServices.push({
          service_id: serviceId,
          service_is_active: isChecked ? 1 : 0,
          price_service: priceService,
        });
      } else {
        updatedServices[existingServiceIndex].service_is_active = isChecked ? 1 : 0;
        updatedServices[existingServiceIndex].price_service = priceService;
      }

      student.services = updatedServices;

      const formattedData = level.students.map((s) => {
        return {
          student_id: s.student_id,
          services: s.services.map((service) => {
            return {
              service_id: service.service_id,
              service_is_active: service.service_is_active,
              price_service: service.price_service,
            };
          }),
        };
      });

      const requestData = {
        students: formattedData,
      };

      PaymentService.updateStatus(requestData)
        .then((response) => {})
        .catch((error) => {
          console.error("An error occurred:", error);
        })
        .finally(() => {
          this.isLoading = false;
        });

      const testLevel = this.testAllStudentsWithServiceInLevel(level, serviceId);
      if (testLevel) {
        service2.selectAll = true;
      }
    },

    ChangeClass(e) {
      this.selectedCourse = null;
      this.params.course_id = [];
      if (e != null) {
        this.params.class = [];
        this.params.class = e.id;

        this.courses = _.orderBy(e.courses, "name");
      } else {
        this.params.class = [];
      }
      this.getResults();
    },
    ChangeLevel(e) {
      if (e != null) {
        this.courses = [];
        this.params.level = e.id;
      } else {
        this.params.class = null;
        this.isSelected = false;
        this.selectedLevel = null;
        this.params.level = null;
      }
      this.params.course_id = [];
      this.selectedClass = null;
      this.selectedCourse = null;
      this.params.class_school_id = [];
      this.params.page = 1;
      this.isSelected = true;
      if (e) {
        this.classes = _.orderBy(e?.classe, "name");
        this.courses = _.orderBy(e.classe?.courses, "name");
      }
      this.getResults();
    },
    ListServices() {
      this.loading = true;
      ServicesService.getAll({
        params: {
          limit: this.params.limit,
          page: this.params.page,
          sort: this.params.sort,
          order: this.params.order,
          active: true,
        },
      }).then(
        (response) => {
          this.services = response.data.data;
          this.services.forEach((element) => {
            if (element.price === null) {
              element.price = 0;
            }
          });
          this.pagination = this.makePagination(response.data.meta, response.data.links);
          this.total = response.data.meta.total;
          this.loading = false;
        },
        (error) => {
          this.loading = false;
        }
      );
    },

    LevelsList() {
      PaymentService.studentsList({
        params: {
          page: this.params.page,
          order: this.params.order,
          limit: this.params.limit,
          sort: this.params.sort,
        },
      })
        .then((response) => {
          this.levels = response.data.data;
          this.setLeveList();
          this.last_page = response.data.meta.last_page;
          this.pagination = this.makePagination(response.data.meta, response.data.links);

        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async setLeveList() {
      this.levels = this.levels.reduce((acc, level) => {
        level.Active = false;
        this.displaying = true;
        acc.push(level);
        return acc;
      }, []);
      await Promise.resolve(); // Resolve immediately to ensure the array is initialized
    },
    getResults(page = null) {
      this.params.page = !page ? this.params.page : page;
      this.loading = true;

      PaymentService.studentsList({
        params: {
          limit: this.params.limit,
          page: this.params.page,
          order: this.params.order,
          sort: this.params.sort,
          class_id: this.params.class,
          type_id: this.params.level,
        },
      }).then(
        (response) => {
          this.levels = response.data.data;
          this.pagination = this.makePagination(response.data.meta, response.data.links);
          this.loading = false;
        },
        (error) => {
          this.loading = false;
        }
      );
    },
    makePagination(meta, links) {
      return {
        current_page: meta.current_page,
        last_page: meta.last_page,
        next_page_url: links.next,
        prev_page_url: links.prev,
      };
    },
    FilterRegister() {
      PaymentService.getFilter({
        params: {},
      }).then(
        (response) => {
          this.levels2 = response.data.types;
        },
        (error) => {
          console.error(error);
        }
      );
    },
  },
};
</script>
<style scoped>
.tout-selectionne {
  border-bottom: 2px solid #e0e7ed;
  background: #f1fafa;
}

.top-filter {
  padding-top: 0;
  padding-bottom: 0;
  margin: 0;
}

.container-select.container-filter.top-register {
  padding-top: 0;
  padding-bottom: 0;
  padding-left: 0;
  margin: 0;
}

.classes-liste.spec-classe table tbody tr td:nth-child(1) {
  color: rgba(55, 120, 121, 1);
  font-size: 13px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0em;
}

.table .container-checkbox .checkmark:after {
  left: 4px;
  top: 1px;
  width: 5px;
  height: 10px;
  border: solid #34b9bb;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.table .tout-selectionne .container-checkbox .checkmark {
  border: 1px solid rgba(55, 120, 121, 1);
}
.table .container-checkbox input:checked ~ .checkmark {
  background-color: white;
}

.absent-class .container-checkbox .checkmark:after {
  left: 4px;
  top: 1px;
  width: 5px;
  height: 10px;
  border: solid #f35b19;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.container-checkbox input:checked ~ .checkmark {
  background-color: white;
  border-color: #e1e1e1;
}

.table__wrapper {
  padding: 0;
}

.classes-liste table tbody td {
  padding: 10px 15px;
}

.classes-liste table tbody tr.item_level {
  background-color: rgb(52 185 187 / 7%);
  border-bottom: 2px solid #e0e7ed;
}

td.td_content_all {
  padding: 0 !important;
}

.level-name {
  font-size: 13px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0em;
  color: rgba(55, 120, 121, 1);
}

.classes-liste.spec-classe table tbody tr td.name-eleve {
  font-size: 12px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
  color: rgba(51, 51, 51, 1);
}

.classes-liste.spec-classe table th {
  padding: 30px;
  border-bottom: none;
  padding: 15px 15px;
}

tr.item_class th {
  width: 20% !important;
}

table.item_table_classes td {
  width: 20% !important;
}
</style>
<style>
@media (min-width: 991px) {
  .default-page-wrapper.is_expanded-body .wrapper-sidebar aside {
    width: 258px;
  }
}
@media (max-width: 991px) {
  aside .menu .link .text {
    font-size: 12px;
  }
  aside .menu .link .material-icons {
    font-size: 14px;
  }
}
</style>